import { forwardRef, useEffect } from "react";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";

export default forwardRef(function Payment(props, ref) {
  const {
    refreshUser,
    clientSecret,
    stripePromise,
    authorizedFired,
    setStripePromise,
    paymentSuccessful,
    setAuthorizedFired,
    paymentMethodAddMode,
    setPaymentSuccessful,
    defaultPaymentMethod,
    setPaymentSetUpDrawer,
    setShowSetupTopSticker,
    setPaymentMethodAddMode,
    setDefaultPaymentMethod,
    handleDrawerClosePayment,
    setAuthorizedCheckPaymentMethod,
  } = props;

  //async function to get stripe config
  useEffect(() => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY));
  }, []);

  return (
    <>
      {clientSecret && stripePromise && (
        <Elements
          key={clientSecret}
          stripe={stripePromise}
          options={{
            clientSecret,
          }}
        >
          <CheckoutForm
            ref={ref}
            refreshUser={refreshUser}
            clientSecret={clientSecret}
            authorizedFired={authorizedFired}
            paymentSuccessful={paymentSuccessful}
            setAuthorizedFired={setAuthorizedFired}
            setPaymentSuccessful={setPaymentSuccessful}
            paymentMethodAddMode={paymentMethodAddMode}
            defaultPaymentMethod={defaultPaymentMethod}
            setPaymentSetUpDrawer={setPaymentSetUpDrawer}
            setShowSetupTopSticker={setShowSetupTopSticker}
            setPaymentMethodAddMode={setPaymentMethodAddMode}
            setDefaultPaymentMethod={setDefaultPaymentMethod}
            handleDrawerClosePayment={handleDrawerClosePayment}
            setAuthorizedCheckPaymentMethod={setAuthorizedCheckPaymentMethod}
          />
        </Elements>
      )}
      <br />
    </>
  );
});
